import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Autocomplete, TextField, CircularProgress,
} from '@mui/material';

export default function OrgSelectModal({ open, onClose, onConfirm, organizations, loading, initialSelected }) {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) setSelected(initialSelected || []);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Selecionar organizações</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          options={organizations}
          getOptionLabel={o => o.name}
          value={selected}
          onChange={(_, value) => setSelected(value)}
          isOptionEqualToValue={(opt, val) => opt.id === val.id}
          loading={loading}
          loadingText="Carregando..."
          noOptionsText="Nenhuma organização encontrada"
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label="Organizações"
              sx={{ mt: 1 }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={() => onConfirm(selected)} disabled={selected.length === 0}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

OrgSelectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  organizations: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  initialSelected: PropTypes.array,
};
